// extracted by css-extract-rspack-plugin
export default {"creditsButton":"creditsButton-u6wIA8"};